<div class="bp-10 flex max-h-[60vh] max-w-fit overflow-scroll rounded-[40px] bg-background-card p-6">
  <div>
    <div class="h-[80.5px] border-b border-solid border-background-disabled">
      <span class="typo-h7-light text-text-tertiary">{{ 'schedule_total_time' | translate }}</span>
      <div class="typo-h5">{{ timePatterns[timePatterns.length - 1].intervalText }} {{ 'schedule_minutes' | translate }}</div>
    </div>
    <div class="relative top-2 grid w-[40px] grid-cols-[1fr]" [style.height]="timePatternInputs.length * 40 + 'px'">
      <div
        class="relative grid h-full overflow-hidden rounded-bl-xl rounded-tl-xl"
        [style.gridTemplateRows]="'repeat(' + timePatternInputs.length + ', 1fr)'"
      >
        <div class="stripes absolute z-0 h-full w-full bg-text-light"></div>
        <div class="relative">
          @for (timePattern of timePatternInputs.controls; track timePattern) {
            @if (timePattern.value.Provider) {
              <div class="z-10 h-full w-full bg-primary-blue"></div>
            }
            @if (timePattern.value.Assistant) {
              <div class="h-full w-full"></div>
            }
            @if (timePattern.value.Chair) {
              <div
                class="z-10 h-full w-full border-l-2 border-r-2 border-primary-blue bg-background-white"
                [ngClass]="{ 'rounded-tl-xl border-t-2': $first, 'rounded-bl-xl border-b-2': $last }"
              ></div>
            }
          }
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="timePatternForm">
    <table>
      <thead>
        <tr formGroupName="bulkSelection">
          <th></th>

          <th>
            <div>
              <h4>{{ 'schedule_provider_time' | translate }}</h4>
              <lib-radio-button [formControlName]="AppointmentTimePattern.PROVIDER" />
            </div>
          </th>

          <th>
            <div>
              <h4>{{ 'schedule_assistant_time' | translate }}</h4>
              <lib-radio-button [formControlName]="AppointmentTimePattern.ASSISTANT" />
            </div>
          </th>

          <th>
            <div>
              <h4>{{ 'schedule_chair_time' | translate }}</h4>
              <lib-radio-button [formControlName]="AppointmentTimePattern.CHAIR" />
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr class="h-2"></tr>

        <ng-container formArrayName="timePatterns">
          @for (timePattern of timePatternInputs.controls; track i; let i = $index) {
            <tr [formGroupName]="i">
              <td class="pr-9">{{ timePatterns[i].intervalText }}</td>

              @for (option of timePatternOptions; track j; let j = $index) {
                <td class="px-[65px]">
                  <lib-radio-button [formControlName]="option" />
                </td>
              }
            </tr>
          }
        </ng-container>
      </tbody>
    </table>
  </form>
</div>
